/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconHelpSmall = createReactComponent("outline", "help-small", "IconHelpSmall", [["path", { "d": "M12 16v.01", "key": "svg-0" }], ["path", { "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-1" }]]);

export { IconHelpSmall as default };
//# sourceMappingURL=IconHelpSmall.mjs.map
